import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import BranchSelectorDialog from './BranchSelectorDialog';
import { BranchName, BranchNameWrapper } from '../../../_metronic/layout/components/style';
import { Button } from '@mui/material';
import { useCustomTheme } from '../../hooks/useCustomTheme';

function BranchPickerMenu() {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const user = useSelector(state => state.auth.user);

  const onClickOpenDialog = () => setOpen(true);
  const onClickCloseDialog = () => setOpen(false);

  const customTheme = useCustomTheme();
  const style = customTheme?.navbar;

  return (
    <>
      <BranchNameWrapper>
        <Button
          sx={{ color: 'white', padding: 0, margin: 0 }}
          endIcon={<ArrowDropDownIcon style={{ color: style.color }} />}
          onClick={onClickOpenDialog}
        >
          <BranchName style={{ color: style.color }}>
            {intl.formatMessage({ id: 'branch' })}: {user?.loggedInBranch?.name}
          </BranchName>
        </Button>
      </BranchNameWrapper>
      <BranchSelectorDialog open={open} onClickCloseDialog={onClickCloseDialog} />
    </>
  );
}

export default BranchPickerMenu;
